export const CategoryItemEvent = (code: number): IGoogleEvent => {
  switch (code) {
    case 11:
      return {
        category: 'category-item-fertillizer-checked',
        action: 'کاربر وارد بخش کود شد',
      };
    case 12:
      return {
        category: 'category-item-pesticide-checked',
        action: 'کاربر وارد بخش سم شد',
      };
    case 13:
      return {
        category: 'category-item-seed-checked',
        action: 'کاربر وارد بخش بذر، نشاء، قلمه، نهال شد',
      };
    case 14:
      return {
        category: 'category-item-worker-checked',
        action: 'کاربر وارد بخش نیروی کار شد',
      };
    case 15:
      return {
        category: 'category-item-tractor-checked',
        action: 'کاربر وارد بخش ماشین آلات شد',
      };
    case 16:
      return {
        category: 'category-item-tools-checked',
        action: 'کاربر وارد بخش ادوات کشاورزی شد',
      };
    case 17:
      return {
        category: 'category-item-farm-checked',
        action: 'کاربر وارد بخش مزرعه و باغ شد',
      };
    case 18:
      return {
        category: 'category-item-lab-checked',
        action: 'کاربر وارد بخش آزمایشگاه شد',
      };
    default:
      return {
        category: '',
        action: '',
      };
  }
};

export const FooterItemEvent = (router: string): IGoogleEvent => {
  switch (router) {
    case '/home':
      return {
        category: 'footer-item-store-checked',
        action: 'کاربر وارد بخش فروشندگان شد',
      };
    case '/buyer':
      return {
        category: 'footer-item-buyer-checked',
        action: 'کاربر وارد بخش خریداران شد',
      };
    case '/post/add/inputGroup':
      return {
        category: 'footer-item-post-checked',
        action: 'کاربر وارد بخش ثبت آگهی شد',
      };
    case '/message':
      return {
        category: 'footer-item-chat-checked',
        action: 'کاربر وارد بخش پیام ها شد',
      };
    case '/profile':
      return {
        category: 'footer-item-profile-checked',
        action: 'کاربر وارد بخش حساب من شد',
      };
    default:
      return {
        category: router,
        action: 'صفحه ناشناخته',
      };
  }
};

export const InputGroupTypeEvent = (code: number): IGoogleEvent => {
  switch (code) {
    case 17:
      return {
        category: 'buyer-item-farm-checked',
        action: 'کاربر در صفحه خریداران وارد بخش مزرعه و باغ شد',
      };
    case 18:
      return {
        category: 'buyer-item-lab-checked',
        action: 'کاربر در صفحه خریداران وارد بخش آزمایشگاه شد',
      };
    default:
      return {
        category: '',
        action: '',
      };
  }
};
// TODO: check
export const PostItemEvent = (code: number): IGoogleEvent => {
  switch (code) {
    case 11:
      return {
        category: 'post-item-fertillizer-checked',
        action: 'کاربر در صفحه ثبت آگهی وارد بخش کود شد',
      };
    case 12:
      return {
        category: 'post-item-pesticide-checked',
        action: 'کاربر در صفحه ثبت آگهی وارد بخش سم شد',
      };
    case 13:
      return {
        category: 'post-item-seed-checked',
        action: 'کاربر در صفحه ثبت آگهی وارد بخش بذر، نشاء، قلمه، نهال شد',
      };
    case 14:
      return {
        category: 'post-item-worker-checked',
        action: 'کاربر در صفحه ثبت آگهی وارد بخش نیروی کار شد',
      };
    case 15:
      return {
        category: 'post-item-tractor-checked',
        action: 'کاربر در صفحه ثبت آگهی وارد بخش ماشین آلات شد',
      };
    case 16:
      return {
        category: 'post-item-tools-checked',
        action: 'کاربر در صفحه ثبت آگهی وارد بخش ادوات کشاورزی شد',
      };
    case 17:
      return {
        category: 'post-item-farm-checked',
        action: 'کاربر در صفحه ثبت آگهی وارد بخش مزرعه و باغ شد',
      };
    case 18:
      return {
        category: 'post-item-lab-checked',
        action: 'کاربر در صفحه ثبت آگهی وارد بخش آزمایشگاه شد',
      };
    default:
      return {
        category: '',
        action: '',
      };
  }
};

export const generalEvents: Record<string, IGoogleEvent> = {
  banner: {
    category: 'post-banner',
    action: 'کاربر در صفحه اصلی روی بنر کیلیک کرد',
  },
  sellers: {
    category: 'post-sellers',
    action: 'کاربر وارد بخش فروشنگان شد',
  },
};
